<!--
  The ELSA mark (AB#21202).

  Two sparks rather than a generic star: it has to read as "generated" at 13px
  in a tab strip, beside four tabs that are plain words.

  It does not animate. A pulse was asked for to draw attention to a new
  feature, and a pulse that never stops is an animation the eye learns to
  ignore in a week and a distraction beside content people are reading. If
  attention is still wanted after rollout, it belongs on the TAB and fired
  once — on an order with a reading nobody has opened — not on every mark on
  the page forever.
-->
<template>
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M9.5 2.6 Q10.8 8.2 16.4 9.5 Q10.8 10.8 9.5 16.4 Q8.2 10.8 2.6 9.5 Q8.2 8.2 9.5 2.6 Z"
    />
    <path
      fill="currentColor"
      d="M17.6 13.2 Q18.3 16.2 21.3 16.9 Q18.3 17.6 17.6 20.6 Q16.9 17.6 13.9 16.9 Q16.9 16.2 17.6 13.2 Z"
    />
  </svg>
</template>
